import { render, staticRenderFns } from "./lista-buscador-seleccion-editar-transportes.vue?vue&type=template&id=aedd5eae&scoped=true&"
import script from "./lista-buscador-seleccion-editar-transportes.vue?vue&type=script&lang=ts&"
export * from "./lista-buscador-seleccion-editar-transportes.vue?vue&type=script&lang=ts&"
import style0 from "./lista-buscador-seleccion-editar-transportes.vue?vue&type=style&index=0&id=aedd5eae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedd5eae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VIcon,VRow,VSpacer})
